var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('d2-page-cover',{attrs:{"title":"功能","sub-title":"在这里可以测试一些 天天有网球后台系统 的系统功能"}},[_c('img',{attrs:{"src":require("./image/icon.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }